import { v4 as uuid } from "uuid"

export const JOB_ENTITY = "job"

export interface Job {
  id: string
  url: string
  jobName: string
  risks: { title: string; origins: string[] }[]
}

/**
 * Crée un Job vide, avec possibilité de surcharger les valeurs.
 */
export const createEmptyJob = (overrides?: Partial<Job>): Job => {
  const base: Job = {
    id: uuid(),
    url: "",
    jobName: "",
    risks: []
  }

  return { ...base, ...overrides }
}
